import { useState } from "react";
import { t } from "../i18n";
import { Link, useNavigate } from "react-router-dom";
import { api, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LangButton } from "../components/LangButton";

export function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-[100dvh] flex flex-col max-w-[480px] mx-auto px-6 pt-[max(48px,env(safe-area-inset-top))] pb-10 fade-up">
      <div className="flex items-center gap-3 mb-10">
        <span className="w-9 h-9 rounded-full border-[4px] border-[#d4af37]" aria-hidden />
        <span className="font-display tracking-[0.25em] text-sm text-muted-foreground flex-1">CÍRCULO</span>
        <LangButton />
      </div>
      <h1 className="text-3xl font-medium mb-2">{title}</h1>
      {subtitle && <p className="text-muted-foreground text-sm mb-8">{subtitle}</p>}
      {children}
    </div>
  );
}

export default function Login() {
  const { loginSuccess } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      loginSuccess(data);
      navigate("/bloqueo", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthLayout title={t("auth.welcome")} subtitle={t("auth.loginSubtitle")}>
      {new URLSearchParams(window.location.search).get("msg") === "eliminada" && <p data-testid="account-deleted-msg" className="mb-4 rounded-xl border border-border bg-secondary p-3 text-sm">{t("auth.deleted")}</p>}
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div>
          <label className="label" htmlFor="email">{t("auth.emailOrUser")}</label>
          <input id="email" data-testid="login-email-input" className="field" type="text" autoComplete="username" autoCapitalize="none" required
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <div>
          <label className="label" htmlFor="password">{t("common.password")}</label>
          <input id="password" data-testid="login-password-input" className="field" type="password" autoComplete="current-password" required
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-[#f43f5e]">{error}</p>}
        <button data-testid="login-submit-btn" className="btn-primary mt-2" disabled={loading}>{loading ? t("auth.loggingIn") : t("auth.login")}</button>
      </form>
      <p className="text-sm text-muted-foreground mt-8">{t("auth.noAccount")} <Link data-testid="go-register-link" className="text-[#f3c649]" to="/registro">{t("auth.create")}</Link>
      </p>
    </AuthLayout>
  );
}
